import React, { useState } from 'react'
import { IconChevronRight, IconChevronDown } from '@tabler/icons-react'
import classNames from 'classnames'
import { isEmpty } from 'lodash'

import { KodiToolMessage } from './KodiToolMessage'

export const KodiToolGroup = ({ messages, isTurnRunning }) => {
  const [open, setOpen] = useState(false)

  if (isEmpty(messages)) {
    return null
  }

  const stepCount = messages.length
  const stepLabel = stepCount === 1 ? '1 step' : `${stepCount} steps`

  return (
    <div
      className={classNames('cowork-tool-group', { 'cowork-tool-group--running': isTurnRunning })}
    >
      <button
        type="button"
        className="cowork-tool-group__toggle"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-label="Toggle tool call details"
      >
        {open ? (
          <IconChevronDown size={12} className="cowork-tool-group__chevron" />
        ) : (
          <IconChevronRight size={12} className="cowork-tool-group__chevron" />
        )}
        <span className="cowork-tool-group__label">{stepLabel}</span>
      </button>
      {open && (
        <div className="cowork-tool-group__items">
          {messages.map((message) => (
            <KodiToolMessage key={message.id} message={message} />
          ))}
        </div>
      )}
    </div>
  )
}
